module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [(!_vm.$store.state.accomodationsFilter.freeSearch) ? _c('div', {
    staticClass: "body",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.expand()
      }
    }
  }, [_c('div', {
    staticClass: "image default-image",
    style: ((_vm.pool && (_vm.pool.image_thumbnail || _vm.pool.image)) ? 'background-image:url(' + (_vm.pool.image_thumbnail || _vm.pool.image) + ')' : 'background-size: cover;')
  }, [(!_vm.pool.hide_map) ? _c('button', {
    staticClass: "link",
    attrs: {
      "aria-label": _vm.pool.units[0].facility && _vm.locations[_vm.pool.units[0].facility.id] ? 'Öppna karta över ' + _vm.locations[_vm.pool.units[0].facility.id].title : 'Öppna karta över området'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openMap()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "map",
      "scale": "2.1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.pool.video) ? _c('button', {
    staticClass: "link",
    attrs: {
      "aria-label": 'Starta film som visar ' + (_vm.pool.display_name || _vm.pool.name)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openMovie()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "film",
      "scale": "2.1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.show_site && _vm.pool.units[0].facility && _vm.locations[_vm.pool.units[0].facility.id]) ? _c('button', {
    staticClass: "link",
    attrs: {
      "aria-label": 'Läs mer information om ' + (_vm.locations[_vm.pool.units[0].facility.id].title)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openLocationInfo()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": _vm.locations[_vm.pool.units[0].facility.id].slug,
      "scale": "2.1"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "details-start"
  }, [_c('p', {
    staticClass: "area-title",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Område:")]), _vm._v(" "), _c('h2', [_vm._v("\n          " + _vm._s((_vm.pool.display_name || _vm.pool.name)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', [_vm._v(_vm._s(_vm.pool.short_description))])]), _vm._v(" "), (_vm.bulletPoints.length) ? _c('ul', {
    staticClass: "features",
    attrs: {
      "aria-label": (_vm.pool.display_name || _vm.pool.name) + ' i korthet'
    }
  }, _vm._l((_vm.bulletPoints), function(point) {
    return _c('li', [_c('span', [_vm._v(_vm._s(point))])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-end"
  }, [(!_vm.pool.hide_map) ? _c('button', {
    staticClass: "link",
    attrs: {
      "aria-label": _vm.pool.units[0].facility && _vm.locations[_vm.pool.units[0].facility.id] ? 'Öppna karta över ' + _vm.locations[_vm.pool.units[0].facility.id].title : 'Öppna karta över området'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openMap()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "map",
      "scale": "2.1"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          Karta\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.pool.video) ? _c('button', {
    staticClass: "link",
    attrs: {
      "aria-label": 'Starta film som visar ' + (_vm.pool.display_name || _vm.pool.name)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openMovie()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "film",
      "scale": "2.1"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          Film\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.pool.units[0].facility && _vm.locations[_vm.pool.units[0].facility.id]) ? _c('button', {
    staticClass: "link",
    attrs: {
      "aria-label": _vm.pool.units[0].facility ? 'Läs mer information om ' + (_vm.locations[_vm.pool.units[0].facility.id].title) : 'Läs mer information om området'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openLocationInfo()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": _vm.locations[_vm.pool.units[0].facility.id].slug,
      "scale": "2.1"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.locations[_vm.pool.units[0].facility.id].title) + "\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.pool.map_link) ? _c('button', {
    staticClass: "link",
    attrs: {
      "aria-label": 'Öppna karta över ' + (_vm.pool.display_name || _vm.pool.name)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openAreaMap()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "pdf-blue",
      "scale": "2.1"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          Områdeskarta\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.lowestUnitPrice > 0) ? _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Pris från")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v("\n            " + _vm._s(_vm._f("currency")(_vm.lowestUnitPrice)) + "\n          ")])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.display_as_group_pools[_vm.pool.id]) ? _c('AccomodationsListUnitsGroup', {
    ref: "unitList",
    attrs: {
      "pool": _vm.pool
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.accomodations.display_as_group_pools[_vm.pool.id]) ? _c('AccomodationsListUnitsList', {
    ref: "unitList",
    attrs: {
      "units": _vm.pool.units
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d38a43aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Accomodation/List/AccomodationsListPool.vue
// module id = 1046
// module chunks = 0